import { fork, select } from 'redux-saga/effects';

import { SubmitStakePayload } from '../staking/types';
import type { SagaIterator } from '@redux-saga/types';

import { SubmitStakeType } from '../../constants';
import { selectSystemRank, selectSystemResultingAmount } from '../../selectors/stakeTypes/system';
import { EntriesBets } from '../../types/entries';
import { RecordOfSystemStakeTypeState } from '../../types/stakeTypes/system';
import { submitStake } from '../staking';

// ---

export default function* processSystem(entries: EntriesBets): SagaIterator {
  const amount: number | null = yield select(selectSystemResultingAmount);

  if (typeof amount !== 'number') {
    console.warn('system amount value is not a number'); // >>>
    return;
  }

  const rank: RecordOfSystemStakeTypeState['rank'] = yield select(selectSystemRank);

  if (typeof rank !== 'number') { // valid amount guarantees valid rank
    console.warn('system rank value is not a number'); // >>>
    return;
  }

  const payloadBets : SubmitStakePayload['bets'] = entries.reduce((acc, entry) => {
    acc.push({
      id: entry.entity.id,
      matchId: entry.entity.matchId,
      price: entry.price,
    });

    return acc;
  }, [] as SubmitStakePayload['bets']);

  const payload: SubmitStakePayload = {
    type: SubmitStakeType.SYSTEM,
    bets: payloadBets,
    rank,
    amount,
  };

  yield fork(submitStake, payload);
}
